<template>
  <vx-card>
    <h3 class="gw-det-title">DataCrédito</h3>
    <p class="gw-det-sub">
      Consulta del historial crediticio del candidato en la central de riesgo.
    </p>

    <!-- Antes esto era una tabla de cuatro columnas para dos valores y dos
         botones, con un "No data Available" debajo cuando no habia
         observaciones. -->
    <div class="gw-dc">
      <div class="gw-dc-estado">
        <span class="gw-dc-chip">{{ project.credit_validation ? 'Consultado' : 'No consultado' }}</span>
      </div>

      <div class="gw-dc-acciones" v-if="project.credit_validation">
        <button
          type="button"
          class="gw-dc-boton"
          @click="openCreditFile(project.credit_archive, 'credit_archive')"
        >
          Ver informe
        </button>
        <button
          type="button"
          class="gw-dc-boton gw-dc-boton--suave"
          @click="openCreditFile(project.credit_photo, 'credit_photo')"
        >
          Ver resumen
        </button>
      </div>
    </div>

    <div class="gw-dc-observaciones" v-if="observaciones">
      <div class="gw-det-label">Observaciones</div>
      <div class="gw-det-texto">{{ observaciones }}</div>
    </div>
  </vx-card>
</template>

<script>
import api from '@/mixins/api.js'
import secureFiles from '@/mixins/secureFiles.js'

export default {
  name: 'ProjectCreditValidation',
  mixins: [api, secureFiles],
  props: {
    project: Object
  },
  computed: {
    observaciones () {
      var o = (this.project || {}).credit_observations
      return o && String(o).trim().length ? o : null
    }
  },
  methods: {
    openCreditFile (url, attachment) {
      this.openSecureFileUrl(url, {
        resourceType: 'project_attachment',
        id: this.project.id,
        attachment
      })
    }
  }
}
</script>

<style scoped>
.gw-dc{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}
.gw-dc-chip{
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 11px;
  border-radius: 11px;
  background: rgba(95, 0, 145, .08);
  color: #5f0091;
}
.gw-dc-acciones{
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.gw-dc-boton{
  font-size: 12.5px;
  font-weight: 600;
  color: #fff;
  background: #5f0091;
  border: 1px solid #5f0091;
  border-radius: 7px;
  padding: 7px 15px;
  cursor: pointer;
}
.gw-dc-boton:hover{
  background: #4d0076;
}
.gw-dc-boton--suave{
  background: #fff;
  color: #5f0091;
}
.gw-dc-boton--suave:hover{
  background: #faf6fc;
}
.gw-dc-observaciones{
  margin-top: 18px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}
</style>
